// extracted by mini-css-extract-plugin
export default {"root":"ShimmerPlaceHolder_root__EQ42K","placeHolderShimmer":"ShimmerPlaceHolder_placeHolderShimmer__9Rlmz"};